import React, { useCallback, useEffect, useState } from 'react';
import Background from '../../shared/components/Background';
import './PageContent.css';
import { fetchBackgroundWithPage } from '../../utils';

export default function PageContent({ page }) {

  const [background, setBackground] = useState()
  
  const fetchBackground = useCallback(async () => {
    const bg = await fetchBackgroundWithPage(page)
    setBackground(bg)
  }, [page])

  useEffect(() => {
    fetchBackground()
  }, [fetchBackground])
  

  return (
    <div className='page-container'>
      <Background size="200" opacity={0.90} url={background?.source_url} />
      {
        page &&
        <div className='page-content'>
          <h1 dangerouslySetInnerHTML={{ __html: page.title?.rendered}}/>
          <div dangerouslySetInnerHTML={{ __html: page.content?.rendered }} />
        </div>
      }
    </div>
  )
}
